import { ChangeDetectionStrategy, Component, inject, InjectionToken, OnInit } from '@angular/core';
import { AddressService } from '@vendasta/businesses';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Business, OrdersRow } from '../interface';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

export const BUSINESS_LINK = new InjectionToken<(order: OrdersRow) => string>('SALES_ORDERS_TABLE_BUSINESS_LINK_URL', {
  providedIn: 'root',
  factory: () => (order: OrdersRow) => `/businesses/accounts/${order.businessId}/details`,
});

@Component({
  selector: 'sales-ui-business-info-cell',
  template: `
    <ng-container *ngIf="business">
      <div class="title">
        <div *ngIf="business.deleted === true; else linkToBusinessDetails">
          {{ business.companyName }}
        </div>
      </div>
      <div class="subtitle">{{ address$ | async }}</div>
      <ng-template #linkToBusinessDetails>
        <a [routerLink]="businessLink(element)">{{ business.companyName }}</a>
      </ng-template>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        min-width: 0;
        max-width: 100%;
      }

      .title {
        font-size: 14px;
        font-weight: 500;
      }

      .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.54);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BusinessInfoCellComponent extends SalesOrderTableCustomComponentDirective implements OnInit {
  business: Business;
  address$: Observable<string>;
  address$$: BehaviorSubject<string> = new BehaviorSubject('');

  businessLink = inject(BUSINESS_LINK);

  constructor(private addressService: AddressService) {
    super();
  }

  ngOnInit(): void {
    this.business = this.element.business;
    if (this.business) {
      this.address$ = this.addressService
        .shortAddress$({
          address1: this.element.business.address,
          address2: this.element.business.address2,
          city: this.element.business.city,
          province: this.element.business.state,
          zip: this.element.business.zip,
          country: this.element.business.country,
        })
        .pipe(
          tap((address) => {
            this.address$$.next(address);
          }),
        );
    }
  }
}
